import { render, staticRenderFns } from "./incomes.vue?vue&type=template&id=f06abc0a&scoped=true"
import script from "./incomes.vue?vue&type=script&lang=js"
export * from "./incomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06abc0a",
  null
  
)

export default component.exports